import { useMemo } from "react";
import {
  Breadcrumb,
  ProductImageGallery,
  ProductInfo,
  ProductTabs,
  ProductDetailLayout,
  StickyAddToCartBar,
  // ProductFAQ,
  // ProductReviews,
  // AskQuestion,
} from "../components/ProductDetail";
import RecommendedProducts from "../components/Products/RecommendedProducts";
import { useProductDetail } from "../hooks/useProductDetail";
import { useRecentlyViewed } from "../hooks/useRecentlyViewed";

const DynamicProductDetail = () => {
  const {
    // Data
    product,
    loading,
    error,
    quantity,
    mainImage,
    selectedTab,
    // recommendedProducts,
    // recommendedLoading,
    isWishlisted,
    wishlistLoading,
    user,

    // Computed values
    originalPrice,
    discountedPrice,
    hasDiscount,

    // Handlers
    handleQuantityChange,
    handleAddToCart,
    handleWishlistClick,
    handleImageChange,
    handleTabChange,
    handleBack,
    handleBackToProducts,
  } = useProductDetail();

  // Recently viewed products
  const productForHistory = useMemo(
    () =>
      product
        ? {
            ...product,
            price: product.usd_price || 0,
            image: mainImage || product.image_paths?.[0] || "",
            description: product.description || "",
            name: product.name || "",
          }
        : null,
    [product, mainImage],
  );

  // @ts-ignore - fixing type mismatch between local and global Product types
  const recentlyViewed = useRecentlyViewed(productForHistory);

  return (
    <ProductDetailLayout
      loading={loading}
      error={error || (!product ? "Product not found" : null)}
      onBackToProducts={handleBackToProducts}
    >
      {product && (
        <>
          <Breadcrumb onBack={handleBack} />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
            <ProductImageGallery
              product={product}
              mainImage={mainImage}
              onImageChange={handleImageChange}
            />

            <ProductInfo
              product={product}
              hasDiscount={hasDiscount}
              originalPrice={originalPrice}
              discountedPrice={discountedPrice}
              quantity={quantity}
              onQuantityChange={handleQuantityChange}
              onAddToCart={handleAddToCart}
              onWishlistClick={handleWishlistClick}
              isWishlisted={isWishlisted}
              wishlistLoading={wishlistLoading}
              user={user}
            />
          </div>

          <ProductTabs
            product={product}
            selectedTab={selectedTab}
            onTabChange={handleTabChange}
            hasDiscount={hasDiscount}
            originalPrice={originalPrice}
          />

          {/* Reviews Section */}
          {/* <ProductReviews productId={product.id} /> */}

          {/* Ask a Question */}
          {/* <AskQuestion
            productName={product.name || "this product"}
            productId={product.id}
          /> */}

          {/* FAQ Section */}
          {/* <ProductFAQ /> */}

          {/* <RecommendedProducts
            products={recommendedProducts}
            loading={recommendedLoading}
            title="You Might Also Like"
          /> */}

          {/* Recently Viewed Products */}
          {recentlyViewed.length > 0 && (
            <RecommendedProducts
              products={recentlyViewed}
              loading={false}
              title="Recently Viewed"
            />
          )}

          {/* Sticky Add to Cart Bar */}
          <StickyAddToCartBar
            productName={product.name || "Product"}
            price={originalPrice}
            hasDiscount={hasDiscount}
            discountedPrice={discountedPrice}
            onAddToCart={handleAddToCart}
            isOutOfStock={(product.quantity || 0) === 0}
          />
        </>
      )}
    </ProductDetailLayout>
  );
};

export default DynamicProductDetail;
